<button
  type="button"
  class="page-size-trigger"
  [matMenuTriggerFor]="menu"
  [disabled]="disabled"
>
  <span>{{ value }}</span>
  <span class="material-icons page-size-trigger__chevron">expand_more</span>
</button>

<mat-menu #menu="matMenu" class="page-size-panel">
  @for (size of sizes; track size) {
    <button mat-menu-item [class.active]="value === size" (click)="select(size)">{{ size }}</button>
  }
</mat-menu>
